export enum ExportPowerBIReportStatusType {
  Undefined = 'Undefined',
  NotStarted = 'NotStarted',
  Running = 'Running',
  Succeeded = 'Succeeded',
  Failed = 'Failed'
}
